export const isDev = process.env.NODE_ENV === 'development';
export const isStaging = process.env.VUE_APP_IS_STAGING === 'true';
export const base =
    isDev ? 'https://localhost:6001/'
        : isStaging
            ? 'https://fakeapps.ncut.edu.tw/ncutuni/'
            : 'https://ncutuni.ncut.edu.tw/';

export const app_name = process.env.VUE_APP_TITLE;

export const SystemKey = '85fa8db3f71f432cb69a3f685e480dcf';
export const TOKEN_KEY = `jwt_${SystemKey}`;

export const MonthTypes = {
    [0]: '日',
    [1]: '夜',
    [2]: '全天'
};

export const Semesters = [
    {
        text: '上學期',
        value: 1,
    },
    {
        text: '下學期',
        value: 2,
    },
    {
        text: '暑修1',
        value: 3,
    },
    {
        text: '暑修2',
        value: 4,
    },
    {
        text: '寒修',
        value: 5,
    }
];

export const PeriodTypes = {
    Day: 0,
    Night: 1,
};

export const ChangeStatus = {
    Success: 0,
    Existed: 1,
    FileError: 2
};

export const DrawMode = {
    Boy: 0,
    Girl: 1,
};

export const FormTypes = {
    Normal: 1,
    Drawable: 2,
    Super: 3
};

export const RoleTypes = {
    Officer: 0,
    SecDirector: 1,
    FstDirector: 2,
    None: 3
};

export const ReplaceTags = {
    Name: 1,
    ApplyDate: 2,
    DenyReason: 3,
    Url: 4,
    DenyAt: 5,
    FinishAt: 6,
    Results: 7
};

export const MailTemplateTypes = {
    Apply: {
        value: 9,
        label: '申請通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate]
    },
    Success: {
        value: 10,
        label: '申請核可通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate, ReplaceTags.FinishAt]
    },
    Drew: {
        value: 11,
        label: '中籤通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate, ReplaceTags.Results]
    },
    Deny: {
        value: 13,
        label: '退回通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate, ReplaceTags.DenyReason,ReplaceTags.DenyAt]
    },
};
export const UploadTypes = {
    PEBookingCertificate: 0,
    PENewsAttaches : 1
};

export const IdentityTypes = {
    None: '-1',
    Employee: '0',
    Student: '1',
    Teacher: '2'
};